<template>
  <div class="partner">
    <div class="partnerTop">
      <div class="partnerTilte">我们的核心优势</div>
      <div class="advantage">
        <div
          v-for="(item, index) in topList"
          :key="index"
          class="advantageEvery"
        >
          <img :src="item.url" alt="" />
          <div class="tilte">{{ item.tilte }}</div>
          <div>{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="partnerTwin">
      <div class="partnerTilte">合作伙伴享受权益</div>
      <div class="equity">
        <div v-for="(item, index) in twinList" :key="index" class="equityEvery">
          <img :src="item.url" alt="" />
          <div>{{ item.tilte }}</div>
        </div>
      </div>
    </div>
    <div class="partnerFooter">
      <div class="partnerTilte">合作伙伴模式</div>
      <div class="schema">
        <div class="schemaTilte">区域合伙人</div>
        <div>
          <div>平台技术支持</div>
          <div>供需两端支持</div>
          <div>运营模式输出</div>
          <div>项目收益共享</div>
        </div>
        <div class="buton" @click="dialogVisible = true">成为伙伴</div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="提示"
      append-to-body
      width="30%"
      :before-close="handleClose"
    >
      <div class="fromClass">
        <div class="tilte">填入信息</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="top"
          label-width="80px"
        >
          <el-form-item label="公司名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="例如：浙江省阿里巴巴控股有限公司"
            ></el-input>
          </el-form-item>
          <el-form-item label="行业类型" prop="type">
            <el-input
              v-model="ruleForm.type"
              placeholder="例如：电子商务"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input
              v-model="ruleForm.contact"
              placeholder="例如：0571-8888888；12200008888"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在区域" prop="district">
            <el-input
              v-model="ruleForm.district"
              placeholder="例如：浙江省西湖区"
            ></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input
              v-model="ruleForm.position"
              placeholder="例如：项目经理"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ruleForm: { name: "", type: "", contact: "", district: "" },
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        type: [{ required: true, message: "请输入行业类型", trigger: "blur" }],
        contact: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
        ],
        district: [
          { required: true, message: "请输入所在区域", trigger: "blur" },
        ],
      },
      topList: [
        {
          url: require("@/assets/hehuoren/human-cost.png"),
          tilte: "节省人力成本",
          text: "灵活应对淡旺季，优化用工结构，降低综合成本",
        },
        {
          url: require("@/assets/hehuoren/Employment-risk.png"),
          tilte: "降低用工风险",
          text: "法律纠纷风险、工伤风险 生产安全风险",
        },
        {
          url: require("@/assets/hehuoren/Input-cost.png"),
          tilte: "合规进项成本",
          text: "平台结算合规 发票完税合规",
        },
      ],
      twinList: [
        {
          url: require("@/assets/hehuoren/matching.png"),
          tilte: "供需精准匹配",
        },
        {
          url: require("@/assets/hehuoren/training.png"),
          tilte: "培训资源",
        },
        {
          url: require("@/assets/hehuoren/legal.png"),
          tilte: "合法合规作业",
        },
        {
          url: require("@/assets/hehuoren/settle-accounts.png"),
          tilte: "便捷结算提现",
        },
        {
          url: require("@/assets/hehuoren/supervise.png"),
          tilte: "实时在线监管",
        },
        {
          url: require("@/assets/hehuoren/send-orders.png"),
          tilte: "优先派单服务",
        },
        {
          url: require("@/assets/hehuoren/insurance.png"),
          tilte: "用工保险",
        },
        {
          url: require("@/assets/hehuoren/data-analysis.png"),
          tilte: "数据追踪与分析",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {
        name: "",
        type: "",
        contact: "",
        district: "",
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.partner {
  font-family: PingFang SC, PingFang SC;
  .partnerTilte {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
  }
  .partnerTwin {
    .partnerTilte {
      color: #ffffff !important;
    }
  }
  .partnerTop {
    padding: 80px 384px;

    .advantage {
      font-weight: 400;
      font-size: 14px;
      color: #606266;
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      .advantageEvery {
        width: 160px;
      }
      .tilte {
        font-weight: 500;
        font-size: 20px;
        color: #141414;
        margin: 10px 0;
      }
    }
  }
}
.partnerTwin {
  background: url("@/assets/hehuoren/citybg.png") no-repeat;
  background-size: 100% 100%;
  padding: 80px 424px 0 424px;
  .equity {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 30px;
    .equityEvery {
      width: 45%;
      display: flex;
      align-items: center;
      padding: 32px 0;
      background: rgba(255, 255, 255, 0.2);
      margin-top: 24px;
      img {
        margin: 0 40px 0 60px;
      }
      div {
        margin-left: 40px;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}

.partnerFooter {
  background: #f4f7fc;
  padding: 80px 0;
  .schema {
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 45px 0;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 28px;
    width: 574px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-left: calc(50% - 287px);
    margin-top: 20px;
    .schemaTilte {
      font-weight: 500;
      font-size: 22px;
      color: #141414;
      line-height: 30px;
      position: relative;
      margin-bottom: 20px;
    }
    .schemaTilte::after {
      content: "";
      position: absolute;
      bottom: 3px;
      left: 43.5%;
      width: 80px;
      height: 4px;
      background-color: rgba(28, 135, 255, 0.8);
    }
    .buton {
      width: 330px;
      background: #1c87ff;
      border-radius: 4px 4px 4px 4px;
      padding: 14px 0;
      font-weight: 500;
      font-size: 16px;
      margin-left: calc(50% - 165px);
      color: #ffffff;
      margin-top: 20px;
    }
    .buton:hover {
      cursor: pointer;
    }
  }
}
.fromClass {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #e40000;
  text-align: left;
  padding: 0 50px;
  .tilte {
    font-weight: 500;
    font-size: 28px;
    color: #000000;
    margin-bottom: 40px;
  }
}

@media (max-width: 750px) {
  .partnerTop {
    padding: 80px 180px !important;
  }
  .partnerTwin {
    padding: 80px 200px 0 200px;
    img {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
